import React from "react";
import cn from "classnames";
import sass from "pages/StepPages/StepFour/Two/Calculate/calculate.module.sass";
import { ReactComponent as ArrowTop } from "images/ArrowsTop.svg";

/**
 * Компонент отрисовывает якоря для навигации на странице формул
 */
export const Anchor: React.FC<{ fields: { [key: string]: any }[]; classAnchor: string }> = ({
	fields,
	classAnchor,
}) => {
	return (
		<div data-comment-false={true} className={cn(sass.anchor, classAnchor)}>
			{!!fields.length ? (
				fields.map((_: any, index) => (
					<div key={index} onClick={() => _.onClick()}>
						<ArrowTop />
						<span>{_.name}</span>
					</div>
				))
			) : (
				<div>
					<ArrowTop />
					<span>К началу</span>
				</div>
			)}
		</div>
	);
};
